// extracted by mini-css-extract-plugin
export var blue = "_14-h";
export var brand = "_14-d";
export var darkGrey = "_14-g";
export var disabled = "_14-6";
export var disabledSubtle = "_14-7";
export var error = "_14-8";
export var green = "_14-i";
export var grey = "_14-f";
export var icon = "_14-0";
export var inherit = "_14-c";
export var lightGrey = "_14-e";
export var orange = "_14-k";
export var pink = "_14-m";
export var primary = "_14-1";
export var purple = "_14-n";
export var quaternary = "_14-4";
export var quinary = "_14-5";
export var red = "_14-l";
export var secondary = "_14-2";
export var success = "_14-b";
export var tertiary = "_14-3";
export var warning = "_14-9";
export var warningSecondary = "_14-a";
export var white = "_14-o";
export var yellow = "_14-j";